import { useMemo } from 'react'
import useSWR from 'swr'
import { useIsClient } from 'usehooks-ts'

import { useAuthContext } from '@/context/AuthContext'
import { useConfigsContext } from '@/context/ConfigsContext'
import { useEnableFull3d } from '@/hooks/useEnableFull3d'
import { createShareComponentProfile } from '@/lib/auth'
import { getPointBalance } from '@/services/community'
import { HubsStoreState } from '@/types/store'

export const useShareComponentProfile = () => {
  const { store, accountId } = useConfigsContext()
  const { isSignedIn } = useAuthContext()
  const isClient = useIsClient()

  const profile = store?.profile
  const htcToken = store?.credentials?.htcToken
  const enableFull3d = useEnableFull3d()

  const { data } = useSWR(!htcToken || enableFull3d ? null : 'pointBalance', () =>
    getPointBalance(htcToken!).then((res) => res?.results?.data),
  )

  const pointBalance = data?.pointBalance || 0
  const displayName = profile?.displayName
  const avatarId = profile?.avatarId
  const avatarSnapshot = profile?.avatarSnapshot
  const avatarGlb = profile?.avatarGlb
  const avatarGenderKey = profile?.avatarGenderKey
  const avatarDataType = profile?.avatarDataType
  const userId = profile?.userId
  const isGamePlus = profile?.isGamePlus

  const isLogoutHash = isClient && window.location.hash === '#logout'

  const shareComponentProfile = useMemo(() => {
    const newProfile = {
      displayName,
      avatarId,
      avatarSnapshot,
      avatarGlb,
      avatarGenderKey,
      avatarDataType,
      userId,
      isGamePlus,
      accountId,
      htcToken,
    } as HubsStoreState['profile']

    return !isLogoutHash && isSignedIn ? createShareComponentProfile(newProfile, pointBalance) : {}
  }, [
    isSignedIn,
    pointBalance,
    displayName,
    avatarId,
    avatarSnapshot,
    avatarGlb,
    avatarGenderKey,
    avatarDataType,
    userId,
    isGamePlus,
    accountId,
    htcToken,
    isLogoutHash,
  ])

  return shareComponentProfile
}
